import { useContext } from 'react';
import { WelletContext } from '../../../context/wellet/welletContext';
import { useNavigate } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import { putEmailsCommunication, putPolicies } from '../../../services';
import { defaultQueryOptions } from '../../../utils/defaultQueryOptions';
import { Show } from '../../../components';
import { FormButton, FormHeader, Loading, PageError, Toast } from '../../../uiComponents/common';
import { useSelector } from 'react-redux';
import { InputEmails } from '@/uiComponents/common';
import { getEmailsCommunication } from '@/services';
import FormRow from '@/components/forms/formRow';

const CallCenterCommunication = ({ t }) => {
  const welletContext = useContext(WelletContext);
  const navigate = useNavigate();
  // Form
  const methods = useForm({
    defaultValues: {
      emails: [],
    },
  });
  const organization = useSelector((state) => state.app.selectedOrganization);

  // Querys
  const emailsQuery = useQuery({
    queryKey: ['emails-communication', organization.marketId],
    queryFn: async () => {
      const data = await getEmailsCommunication(welletContext, organization.marketId);
      return data;
    },
    onSuccess: (data) => {
      methods.reset({
        emails: data?.data?.map((d) => ({ label: d, value: d })) ?? [],
      });
    },
    ...defaultQueryOptions,
  });

  // Mutations
  const emailsMutation = useMutation({
    mutationFn: (body) => {
      putEmailsCommunication(welletContext, body, organization.marketId);
    },
  });

  const onSubmit = (data) => {
    emailsMutation.mutate(data?.emails?.map((e) => e.value));
  };

  const handleRedirectCancel = () => {
    navigate('/settings');
  };

  return (
    <>
      <Show>
        <Show.When isTrue={emailsQuery.isLoading || emailsQuery.isFetching}>
          <Loading />
        </Show.When>
        <Show.When isTrue={emailsQuery.isError}>
          <PageError />
        </Show.When>
        <Show.Else>
          <FormProvider {...methods}>
            <form key={1} onSubmit={methods.handleSubmit(onSubmit)} className='mt-3'>
              <FormHeader
                title={t('communication.title')}
                subtitle={t('communication.description')}
                border={true}
                endComponent={
                  <FormButton
                    handleRedirect={() => {}}
                    clearForm={handleRedirectCancel}
                    all={false}
                    nextStep={true}
                    isDisabled={!emailsMutation.isIdle}
                  />
                }
              />
              <FormRow
                text={t('emails.title')}
                isFirst={false}
                withBorder={false}
                endComponent={
                  <InputEmails
                    name={'emails'}
                    label={t('emails.label')}
                    placeholder={t('emails.placeholder')}
                    className={'col-xl-8 col'}
                  />
                }
              />
            </form>
          </FormProvider>

          <Show.When isTrue={emailsMutation.isSuccess}>
            <Toast
              message={t('communication.toast.success')}
              type={`SUCCESS`}
              onCallback={() => emailsMutation.reset()}
            />
          </Show.When>
          <Show.When isTrue={emailsMutation.isError}>
            <Toast
              message={t('communication.toast.errors')}
              type={`ERROR`}
              onCallback={() => emailsMutation.reset()}
            />
          </Show.When>
        </Show.Else>
      </Show>
    </>
  );
};

export default CallCenterCommunication;
